import React from "react";
import { useStoredItem } from "../../../state/InternalContext";

interface ItemValueProps {
    item: string,
}

/***
 * A source component that returns the value of a stored item.
 * 
 * Params:
 *      store: The name of the store
 */
export const ItemValue = React.memo(function ItemValue({ item }: ItemValueProps): React.ReactElement {
    const storedItem = useStoredItem(item);
    return <>{storedItem?.value?.toString().trim() || ""}</>;
});